import { useEffect, useMemo, useState } from 'react'
import { TheatricalShowtimeVenue } from '@/types/codegen-federation'
import { getItemOrFirstEntry } from '@/utils/array-utils'
import { logger } from '@/utils/logging'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

interface Props {
  venues: TheatricalShowtimeVenue[]
}
export const useFindQueryVenue = ({ venues }: Props) => {
  const { isReady, query } = useSafeRouter()
  const [venue, setVenue] = useState<TheatricalShowtimeVenue | undefined>()

  useEffect(() => {
    try {
      if (!isReady) return
      if (!venues || venues.length === 0) return

      const venueId = getItemOrFirstEntry(query?.selectedVenue)
      if (!venueId) return

      const venue = venues.find((v) => v.id === venueId)
      if (venue) setVenue(venue)
    } catch (err) {
      logger().error('An error occurred while attempting to extract the venue from the query params', err)
    }
  }, [isReady, query, venues])

  return useMemo(() => {
    return { venue }
  }, [venue])
}
